import { render, staticRenderFns } from "./ParagraphItem.vue?vue&type=template&id=8405f9ea&scoped=true&"
import script from "./ParagraphItem.vue?vue&type=script&lang=js&"
export * from "./ParagraphItem.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphItem.vue?vue&type=style&index=0&id=8405f9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405f9ea",
  null
  
)

export default component.exports